// import axios from "axios";
import config from "../config";

// Function to get the new access token using the refresh token
export const getNewAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");

  try {
    const response = await fetch(
      `${config.apiBaseUrl}/api/auth/refresh-access-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken }),
      }
    );

    const data = await response.json();

    if (response.ok) {
      localStorage.setItem("accessToken", data.accessToken); // Store the new access token
      return data.accessToken; // Return the new access token
    } else {
      console.log("Refresh token is invalid. Please log in again.");
      return null;
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    return null;
  }
};
